import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface RegistrationReasonObject {
  id: number;
  titleEn: string;
  titleAr: string;
  isActive: boolean;
}

export interface RegistrationReasonsListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  reasons: Array<RegistrationReasonObject>;
  errors: unknown;
}

@Module
export default class RegistrationsReasonsModule
  extends VuexModule
  implements RegistrationReasonsListInfo
{
  reasons = [] as Array<RegistrationReasonObject>;
  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  /**
   * Get areas list
   * @returns Array<AreaObject>
   */
  get reasonsList(): Array<RegistrationReasonObject> {
    return this.reasons;
  }

  /**
   * Get all none ive areas list
   * @returns Array<AreaObject>
   */
  get allListRegistrationReasons(): Array<RegistrationReasonObject> {
    return this.reasons;
  }

  /**
   * Get total items
   * @returns number
   */
  get registrationReasonsListCount(): number {
    return this.totalItems;
  }

  @Mutation
  [Mutations.SET_REGISTRATION_REASONS](data) {
    this.reasons = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_REGISTRATION_REASON_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.RESET_REGISTRATION_REASONS_LIST]() {
    this.reasons = [] as Array<RegistrationReasonObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Action
  [Actions.RESET_REGISTRATION_REASONS_STORE]() {
    this.context.commit(Mutations.RESET_REGISTRATION_REASONS_LIST);
  }

  @Action
  [Actions.CREATE_REGISTRATION_REASON](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/settings/registration-reasons', data)
      .then(() => {
        this.context.commit(Mutations.RESET_REGISTRATION_REASONS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.DELETE_REGISTRATION_REASON](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/settings/registration-reasons', id)
      .then(() => {
        this.context.commit(Mutations.RESET_AREAS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_REGISTRATION_REASON]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/settings/registration-reasons', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_REGISTRATION_REASONS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_REGISTRATION_REASON_CURRENT_PAGE](val) {
    this.context.commit(Mutations.SET_REGISTRATION_REASON_CURRENT_PAGE, val);
  }

  @Action
  [Actions.GET_REGISTRATION_REASONS]() {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/settings/registration-reasons', {
      params: { page: this.currentPage },
    })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_REGISTRATION_REASONS, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }

  @Action
  [Actions.GET_REGISTRATION_REASON](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get(`/settings/registration-reasons`, id);
  }
}
